import React from "react";
import { Autocomplete, MenuItem, TextField, Typography } from "@mui/material";
import { ReactComponent as ArrowDownwardIcon } from "../../../../assets/icons/arrow-downward.svg";
import { searchableSelectStyle } from "../../../../assets/MUIStyles/commonStyles";

const SearchableSelect = ({
  value,
  setValue,
  options,
  placeholder = "Select an option",
}) => {
  return (
    <Autocomplete
      value={options.find((opt) => opt.value === value) || null}
      onChange={(event, newValue) => setValue(newValue?.value || "")}
      options={options}
      getOptionLabel={(option) => option.label || ""}
      renderInput={(params) => (
        <TextField
          {...params}
          placeholder={placeholder}
          sx={searchableSelectStyle.inputStyles}
          slotProps={{
            input: {
              ...params.InputProps,
            },
          }}
        />
      )}
      isOptionEqualToValue={(option, value) => option.value === value}
      renderOption={(props, option) => (
        <MenuItem {...props}>
          <Typography className="font-13-500">{option.label}</Typography>
        </MenuItem>
      )}
      sx={searchableSelectStyle.container}
      popupIcon={<ArrowDownwardIcon />}
    />
  );
};

export default SearchableSelect;
